import { TransactionPartType } from '@g2-shared/api-client/generated/settlement-app';

export const TransactionPartTypeLabelMapper: Record<TransactionPartType, string> = {
  [TransactionPartType.ALL]: 'All',
  [TransactionPartType.COMMISSION]: 'Commission',
  [TransactionPartType.FEE]: 'Fee',
  [TransactionPartType.PRINCIPAL]: 'Principal',
};
